import { withStyles } from '@material-ui/core/styles';

import EditForm from '../maintainer/edit';
import Form from './form';
import Service from '../../services/health-plan-service';
import { isRequired } from '../../libraries/validators';
import { reduceSpaces } from '../../libraries/utils';
import { editionMaintainer as styles } from '../maintainer/styles';

const Edit = props => {
  const service = Service;

  const getErrors = values => {
    const errors = {};
    const minimumValues = { range: values.range, coverage: values.coverage };
    const newValues = Object.entries(minimumValues).reduce(reduceSpaces, {});
    isRequired(errors, newValues);

    return errors;
  };

  return {
    getErrors,
    service,
    keyName: 'id'
  };
};

export default withStyles(styles)(EditForm(Edit)(Form));
